import { useMutation, useQuery } from "@tanstack/react-query";
import FETCHER from "./_fetcher";

interface UploadImageResponse {
  imageUrl: string;
}
export const uploadImage = async (file: File) => {
  const formData = new FormData();
  formData.append("image", file); // Assuming single image, for multiple use a loop
  const result = await FETCHER.post<UploadImageResponse>(
    `/image-upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return result;
};

export const useUploadImage = () => {
  const { data, mutateAsync, isPending } = useMutation({
    mutationFn: uploadImage,
    onSuccess: () => {},
  });

  return {
    data: data,
    uploadImageAsync: mutateAsync,
    isPending,
  };
};

export const getImageUrl = async (key: string) => {
  const result = await FETCHER.get<string>(
    `/image-upload/url/${encodeURIComponent(key)}`
  );
  return result;
};
export const useGetImageUrl = (key: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["getImageUrl", key],
    queryFn: () => getImageUrl(key),
  });

  return {
    imageUrl: data?.data,
    isLoading,
  };
};

export const getProductImageFile = async (key: string): Promise<Blob> => {
  const result = await FETCHER.get(
    `/image-upload/product-url/${encodeURIComponent(key)}`,
    {
      responseType: "blob",
    }
  );
  return result.data as Blob;
};

export const useGetProductImageFile = (key: string, enabled = true) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["getProductImageFile", key],
    queryFn: () => getProductImageFile(key),
    enabled: enabled && !!key,
  });

  return {
    imageBlob: data,
    isLoading,
    error,
  };
};
